<template>
  <div>
    <app-notification :from-boti="false"
                  :title="'תמונת החודש הראשונה שלך מוכנה!'"
                  :text="'אפשר לערוך את ההוצאות וההכנסות בלחיצה על כפתור העריכה ✏️'"
                  :notification-buttons="[
                    {
                      size:'normal',
                      title:'איך נבנתה תמונת החודש?',
                      subTitle: 'אפשר לקרוא כאן הסבר מפורט',
                      variant: 'primary',
                      action: openTour,
                    },
                  ]"></app-notification>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import CashflowTourPopup from '../../../../../../../base-components/onboarding/CashflowTourPopup.vue';
import ModalBus from '../../../../../../../event-bus/modal-bus';

export default {
  name: 'CashflowTourNotification',
  components: {
    AppNotification,
  },
  created() {
    Segment.trackUserGot('CashflowTourNotificationShown');
  },
  computed: {
    ...mapState('session', ['customerId']),
  },
  methods: {
    ...mapActions('applicationState', ['closeTour']),
    openTour() {
      Segment.trackUserInteraction('CashflowTourOpenClicked');
      ModalBus.$emit('open', {
        component: CashflowTourPopup,
        props: {
          closeTour: this.closeTour,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
